import React from "react"
import PropTypes from "prop-types"

import WPImage, { DISPLAY_MODE } from "./WPImage"

import * as twoColumnHeroWithImageRightStyles from "../../styles/TwoColumnHeroWithImageRight.module.css"

function TwoColumnHeroWithImageRight(props) {
  const [elevatedHeight, setElevatedHeight] = React.useState(0)
  const [elevatedLeft, setElevatedLeft] = React.useState(0)
  const [elevatedWidth, setElevatedWidth] = React.useState(0)
  const contentRef = React.useRef(null)

  React.useLayoutEffect(() => {
    if (props.mode !== CONTAINMENT_MODE.elevated) return

    if (contentRef.current) {
      const boundingClientRef = contentRef.current.getBoundingClientRect()
      if (boundingClientRef && boundingClientRef.bottom)
        setElevatedHeight(boundingClientRef.bottom)
      if (boundingClientRef && boundingClientRef.bottom) {
        setElevatedLeft(
          boundingClientRef.left + Math.ceil(boundingClientRef.width / 2),
        )
        setElevatedWidth(Math.ceil(boundingClientRef.width / 2))
      }
    }
  }, [props.mode])

  const withHiddenSugestions =
    props.className && props.className.includes(`icw-with-hidden-suggestions`)

  if (props.mode === CONTAINMENT_MODE.background) {
    return (
      <div
        className={`container-fluid ${twoColumnHeroWithImageRightStyles.innerWrapper} containment-mode-${props.mode} ${props.className}`}
      >
        <div className={`row g-0`}>
          <div className={`col`}>
            <div style={{ display: "grid", gridAutoRows: "1fr" }}>
              <div
                className={`grid-one`}
                style={{
                  gridArea: "1/1",
                  position: "relative",
                  placeItems: "left",
                  display: "grid",
                  zIndex: 2,
                }}
              >
                {/* Any content here will be left in the component */}
                <div className={`row`}>
                  <div className={`col-12 col-lg-6 ${props.contentClass}`}>
                    {props.children}
                    {withHiddenSugestions && (
                      <span className={twoColumnHeroWithImageRightStyles.pigsNose}>
                        <svg
                          width="100%"
                          height="100%"
                          viewBox="0 0 1914 2048"
                          preserveAspectRatio="xMidYMid meet"
                          xmlns="http://www.w3.org/2000/svg"
                          className={`circle-container`}
                        >
                          <a
                            href="https://airtable.com/appajWEeCTdxi0r8z/pagic72xlEjBXW2Sv/form"
                            target="_blank"
                          >
                            <circle r="50" cx="2200" cy="715" fill="transparent" />
                          </a>
                        </svg>
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div
                className={`d-none d-lg-flex ${twoColumnHeroWithImageRightStyles.backgroundContainmentImage} ${props.imageClass}`}
                style={{
                  gridArea: "1/1",
                  objectFit: "cover",
                  placeItems: "right",
                  zIndex: withHiddenSugestions ? 2 : 1,
                }}
                objectfit="cover"
                placeholderstyle={{
                  objectFit: `cover`,
                  objectPosition: `right bottom`,
                }}
                imgstyle={{
                  objectFit: `cover`,
                  objectPosition: `right bottom`,
                }}
                transformoptions={{ fit: "cover" }}
              >
                <WPImage
                  holder={props.imageHolder}
                  selector={props.imageSelector}
                  mode={DISPLAY_MODE.normal}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (props.mode === CONTAINMENT_MODE.elevated) {
    return (
      <div
        className={`${twoColumnHeroWithImageRightStyles.innerWrapper} containment-mode-${props.mode} ${props.className}`}
      >
        <div className={`row`}>
          <div className={`col`}>
            <div ref={contentRef} className={`row`}>
              <div className={`col-12 col-lg-6 ${props.contentClass}`}>
                {props.children}
              </div>
            </div>
            <div
              className={`col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 ${twoColumnHeroWithImageRightStyles.elevatedContainmentImage} ${props.imageClass}`}
              style={{
                gridArea: "1/1",
                objectFit: "cover",
                placeItems: "right",
                zIndex: 1,
              }}
              objectfit="cover"
              placeholderstyle={{
                objectFit: `cover`,
                objectPosition: `right bottom`,
              }}
              imgstyle={{
                objectFit: `cover`,
                objectPosition: `right bottom`,
              }}
              transformoptions={{ fit: "cover" }}
            >
              <WPImage
                holder={props.imageHolder}
                selector={props.imageSelector}
                mode={DISPLAY_MODE.normal}
                style={{
                  height: elevatedHeight,
                  width: elevatedWidth,
                  left: elevatedLeft,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className={`container-fluid ${twoColumnHeroWithImageRightStyles.innerWrapper} containment-mode-${props.mode} ${props.className}`}
    >
      <div className={`row`}>
        <div className={`col-12 col-lg-6 ${props.contentClass}`}>
          {props.children}
        </div>
        <div
          className={`col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 ${twoColumnHeroWithImageRightStyles.innerImage} ${props.imageClass}`}
        >
          <WPImage
            holder={props.imageHolder}
            selector={props.imageSelector}
            mode={props.imageDisplayMode}
            className={twoColumnHeroWithImageRightStyles.normalContainmentImage}
          />
        </div>
      </div>
    </div>
  )
}

export const CONTAINMENT_MODE = {
  normal: `normal`,
  background: `background`,
  elevated: `elevated`,
}

export const IMAGE_DISPLAY_MODE = DISPLAY_MODE

TwoColumnHeroWithImageRight.defaultProps = {
  mode: CONTAINMENT_MODE.normal,
  imageDisplayMode: DISPLAY_MODE.normal,
}

TwoColumnHeroWithImageRight.propTypes = {
  mode: PropTypes.oneOf(Object.keys(CONTAINMENT_MODE)).isRequired,
  contentClass: PropTypes.string.isRequired,
  imageClass: PropTypes.string,
  imageHolder: PropTypes.object.isRequired,
  imageSelector: PropTypes.string.isRequired,
  imageDisplayMode: PropTypes.oneOf(Object.keys(DISPLAY_MODE)).isRequired,
}

export default TwoColumnHeroWithImageRight
